import React from 'react';
var MarketplaceProductCardContext = /*#__PURE__*/React.createContext({});
export default MarketplaceProductCardContext;
/**
 * Defines a context to pass props to MarketplaceProductCard and KetoProductCard where
 * not normally available through structured-content.
 */

var MarketplaceProductCardContextProvider = function MarketplaceProductCardContextProvider(_ref) {
  var _ref$props = _ref.props,
      props = _ref$props === void 0 ? {} : _ref$props,
      _ref$ketoProps = _ref.ketoProps,
      ketoProps = _ref$ketoProps === void 0 ? {} : _ref$ketoProps,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(MarketplaceProductCardContext.Provider, {
    value: {
      props: props,
      ketoProps: ketoProps
    }
  }, children);
};

export { MarketplaceProductCardContextProvider }; // This can be removed once there are TypeScript interfaces for marketplace-product-card

if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable global-require, @typescript-eslint/no-var-requires */
  var PropTypes = require('prop-types');

  var MarketplaceProductCard = require('@nerdwallet/react-marketplace-product-card');

  var _require = require('@nerdwallet/react-marketplace-product-card'),
      KetoProductCard = _require.KetoProductCard;
  /* eslint-enable global-require, @typescript-eslint/no-var-requires */


  MarketplaceProductCardContextProvider.propTypes = {
    props: PropTypes.shape(MarketplaceProductCard.propTypes),
    ketoProps: PropTypes.shape(KetoProductCard.propTypes),
    children: PropTypes.node.isRequired
  };
}